module.exports = __webpack_public_path__ + "img/44.b529263b.png";